export default __webpack_public_path__ + "static/smsc_bucket_hat_2-eb5fd019dce3dc19140cd39721637398.png";